import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  buttonBoxStylesCP,
  buttonBoxStylesContainerTelcel,
} from "../../styles/buttonBox";
import {
  SERVICE_ID_TELCEL_POSPAGO,
  SERVICE_ID_TELCEL_PLANES,
  AMIGO_PAGUITOS,
  SERVICE_ID_TELCEL_RECARGA
} from '../../constants';
import { getHasDomiciliation } from "../../store/actions/domiciliation";
import ModalCardLoader from "../molecules/ModalCardLoader";
import { isObjectEmpty } from "../organisms/utils";
import HasDomiciliationModal from "../molecules/HasDomiciliationModal";
import { getMessengerService } from "../../store/actions";
import { executeTaggeo } from "../../store/actions";
import * as sdkclaro from '@claro/sdkclaromicrofront';

import HasFavoriteServices from "../molecules/HasFavoriteServices";
export default class ButtonBoxContainer extends Component {
  constructor(props) {
    super(props);
    this.buttonDomiciliationRef = React.createRef();
    this.state = {
      buttonBox: [],
      newRequestDomiciliationService: false,
      isFavoriteServices: false,
    };
  }

  componentDidMount() {
    const { input, isContainerTelcel, getMessengerService } = this.props;
    if (input.cp && !isContainerTelcel) {
      this.setState({ buttonBox: input.cp });
    }
    getMessengerService("PagosProgramados");
    this.assignTagServiceTelcel(this.props.serviceId);
  }

  assignTagServiceTelcel(serviceId) {
    let newTagServiceId;

    switch (true) {
      case (serviceId === SERVICE_ID_TELCEL_PLANES):
        newTagServiceId = 'telcelAmigoSinLimitePs';
        break;
      case (serviceId === SERVICE_ID_TELCEL_POSPAGO):
        newTagServiceId = 'TelcelPospagoPS';
        break;
        case (serviceId === AMIGO_PAGUITOS):
          newTagServiceId = 'amigopaguitos';
          break;
      case (serviceId === SERVICE_ID_TELCEL_RECARGA):
        newTagServiceId = 'serviciopagotelcel';
        break;
      default:
        newTagServiceId = this.props.tagServiceId;
    }

    if (this.state.tagServiceId !== newTagServiceId) {
      this.setState({ tagServiceId: newTagServiceId })
    };
  }

  getStyles() {
    return this.props.isContainerTelcel
      ? buttonBoxStylesContainerTelcel
      : buttonBoxStylesCP;
  }

  handleOnclick = (e, type) => {
    const { tagServiceId } = this.state
    const {
      handleInputButtonFunction,
      getHasDomiciliation,
      accountValue,
      serviceId,
      executeTaggeo,
      canManageFavorites,
      isClaroPartner,
    } = this.props;
    if (type === "escanear") {
      handleInputButtonFunction(e, "ocr");
    }
    if (type === "domiciliar") {
      getHasDomiciliation(accountValue, serviceId);
      this.setState({ newRequestDomiciliationService: true });
      executeTaggeo({
        action: "Click Domiciliar",
        step: "Formulario de pago",
        service: tagServiceId,
      });
    }
    if (type === "favoritos" && canManageFavorites && !isClaroPartner ) {
      this.setState({ isFavoriteServices: true });
      executeTaggeo({
        action: "Click Guardados",
        step: "Formulario de pago",
        service: tagServiceId,
      });
    }
  };
  closeModalFavoriteServices = () => {
    this.setState({ isFavoriteServices: false });
  };
  render() {
    const styles = this.getStyles();
    const { buttonBox, isFavoriteServices, tagServiceId, newRequestDomiciliationService } =
      this.state;
    const {
      amount,
      accountValueValidLength,
      accountValue,
      paymentMethods,
      hasDmResponse,
      isLoadingServiceDomiciliation,
      hasDmError,
      history,
      goToDomiciliationForm,
      amountTelcelPospago,
      canManageFavorites,
      isContainerTelcel,
      handleSetFavValue,
      isClaroPartner
    } = this.props;
    return (
      <>
        <div style={styles.wrapper}>
          {buttonBox.map((button, index) => {
            let active = true;
            if (button.id === "domiciliar") {
              if (
                !goToDomiciliationForm &&
                (parseFloat(amount) <= 0 ||
                  !paymentMethods ||
                  !paymentMethods.hasN2 ||
                  !accountValueValidLength ||
                  accountValueValidLength !== accountValue.length)
              ) {
                active = false;
              }
              setTimeout(() => {
                if (
                  !isObjectEmpty(hasDmResponse) &&
                  !hasDmResponse.data.domiciliation &&
                  goToDomiciliationForm &&
                  this.buttonDomiciliationRef.current
                ) {
                  this.buttonDomiciliationRef.current.click();
                }
              }, 500);
            }
            if (button.id === "cambiar") {
              return (
                <button
                  style={styles.button}
                  disabled={!active}
                  key={index}
                  onClick={() => {
                    const url = {
                      app: "startEventNoClose",
                      to : "openMicroApp",
                      parameters: JSON.stringify({microAppId: "telcelAmigoSinLimitePs"}),
                  };
                  setTimeout(() => {
                      sdkclaro.getInstance().openNative(
                          JSON.stringify(url),
                          () => {},
                          () => {},
                      );
                  }, 1000);
                  }}
                >
                  <span style={styles.buttonText}>{button.text}</span>
                </button>
              );
            }
            return button.id === "favoritos" &&
              !canManageFavorites ? (
              <></>
            ) : (
              <>
                {button.id === "favoritos" && !isContainerTelcel && isClaroPartner && canManageFavorites ?
                  <></>
                :  
                  <button
                    style={active ? styles.button : styles.buttonDisabled}
                    disabled={!active}
                    key={index}
                    onClick={(e) => {
                      this.handleOnclick(e, button.id);
                    }}
                    ref={
                      button.id === "domiciliar" ? this.buttonDomiciliationRef : ""
                    }
                  >
                    <img
                      src={active ? button.iconEnabled : button.iconDisabled}
                      style={styles.buttonIcon}
                    />
                    <span style={styles.buttonText}>{button.text}</span>
                  </button>
                }
              </>
            );
          })}
        </div>
        <ModalCardLoader isOpen={isLoadingServiceDomiciliation} />
        {(newRequestDomiciliationService &&
          !isLoadingServiceDomiciliation &&
          !isObjectEmpty(hasDmResponse)) ||
        hasDmError ? (
          <HasDomiciliationModal
            hasDmResponse={hasDmResponse}
            hasDmError={hasDmError}
            history={history}
            accountValue={accountValue}
            amount={amount}
            tagServiceId={tagServiceId}
          />
        ) : (
          <></>
        )}

        {isFavoriteServices && (
          <HasFavoriteServices
          configImgService={this.props.configImgService}
            isFavoriteServices={isFavoriteServices}
            isContainerTelcel={isContainerTelcel}
            closeModalFavoriteServices={this.closeModalFavoriteServices}
            serviceId={this.props.serviceId}
            tagServiceId={tagServiceId}
            handleSetFavValue={handleSetFavValue}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const {
    domiciliationReducer: {
      hasDomiciliationServiceResponseError,
      hasDomiciliationServiceResponseSuccess,
      isLoadingServiceDomiciliation,
      goToDomiciliationForm,
    },
    payments: { paymentMethods, amountTelcelPospago, PAYMENT_SERVICE_CONF },
  } = state;
  return {
    paymentMethods: paymentMethods,
    hasDmError: hasDomiciliationServiceResponseError,
    isLoadingServiceDomiciliation,
    hasDmResponse: hasDomiciliationServiceResponseSuccess,
    canManageFavorites: state.payments.canManageFavorites,
    goToDomiciliationForm,
    amountTelcelPospago,
    isClaroPartner: PAYMENT_SERVICE_CONF.isClaroPartner,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getHasDomiciliation,
      getMessengerService,
      executeTaggeo,
    },
    dispatch
  );
}

ButtonBoxContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonBoxContainer);
